interface PublishToolProps {
  page: string;
}

const PublishTool = ({ page }: PublishToolProps) => {
  return <></>;
};

export default PublishTool;
